import { AppModule } from '@/shared/types';
import * as routes from './routes';

export const HomeModule: AppModule = {
  routes,
};

